<template>
  <div class="start-ad">
    <a href="http://xia.liaoyuyy.com/3ydke4" target="_blank">
      <van-image fit="fill" height="100vh" :src="liaoyuAdImg"/>
    </a>
  </div>
</template>

<script>
import store from "@/store"
import API from "@/api";

const liaoyuAdImg = "https://qiniu2.58vips.com/liaoyu.jpg";

export default{
  name: 'StartAd',
  data() {

    const userStore = store.userStore();

    API.user.doAdRead(userStore.getDeviceId())

    return {
      liaoyuAdImg
    }
  },
}

</script>

<style scoped lang="less">
.start-ad{
  .van-image{
    display: block;
  }
  .van-image__img{
    height: 100vh;
  }
}
</style>